export default "__VITE_ASSET__CPPvCK3Z__"